export const N77_04 = {
    "columns": 3,
    "rows": 2,
    "visual": {
        "id": 14,
        "type": "summary2",
        "colorTheme": "colorTheme1",
        "title": "Receivables Summary",
        "binding": {
            "data": {
                "title": '',
                "value": '',
                "endpoint": "N77.4",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {

                    }
                }
            }
        }
    }
}